import {Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { IGX_DIALOG_DIRECTIVES, IgxDialogComponent, IgxDialogModule } from '@infragistics/igniteui-angular/dialog';
import { OverlaySettings } from '@infragistics/igniteui-angular/core';
import { IgxIconComponent, IgxIconModule } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleModule } from '@infragistics/igniteui-angular/directives';
import { IGX_NAVBAR_DIRECTIVES, IgxNavbarModule } from '@infragistics/igniteui-angular/navbar';
import {INeodataBtns} from "../../../../core/models/interfaces/generico-interface";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-alert-dialog-custom-promise',
  templateUrl: './alert-dialog-custom-promise.component.html',
  styleUrls: ['./alert-dialog-custom-promise.component.scss'],
  imports: [
    IgxDialogModule,
    IGX_DIALOG_DIRECTIVES,
    TranslateModule,
    IgxNavbarModule,
    IGX_NAVBAR_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxIconModule,
    IgxIconComponent,
    IgxFocusDirective,
    IgxRippleModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AlertDialogCustomPromiseComponent implements OnInit {
  @ViewChild('alert', {static: true})
  public alertDialog: IgxDialogComponent;

  @Output() evtResuelto = new EventEmitter<string>();

  public alertTitulo: string;
  public alertIcon: string;
  public alertMensaje: string;
  public arrayBtn: INeodataBtns[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  public abrir(mensaje: string, titulo: string, icon: string, arrayBtn: INeodataBtns[], overlaySettings: OverlaySettings) {
    this.alertTitulo = titulo;
    this.alertIcon = icon;
    this.alertMensaje = mensaje;
    this.arrayBtn = arrayBtn;
    this.alertDialog.open(overlaySettings);
  }

  public onClick(opcion: string) {
    this.alertDialog.close();
    this.evtResuelto.emit(opcion);
  }
}
